<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import DashboardComponent from './DashboardComponent.vue';

    export default {
    name: 'DashboardPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, DashboardComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
            <LeftNavMenu />
            <DashboardComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>

